import "./Assets/Styles/main.css"
import Start from './Components/Start'
import AllFlooring from './Components/AllFlooring';
import Gallery from './Components/Gallery';
import Refrences from './Components/Refrences';
import Contact from './Components/Contact';
import WhyUs from "./Components/WhyUs";
function App() {
  return (
    <>

    <Start />
    <AllFlooring />
        <WhyUs />
    <Gallery />
    <Refrences />
    <Contact />
    </>
  );
}

export default App;
